import React, { Component } from "react";
import "../../styles/Header.css";
import "../../styles/CRUDAccessSelect.css";
import { currentLocals } from "../../languages/languages.js";

class CRUDAccess extends Component {
  constructor() {
    super();
    this.OpenCRUDAccessMenu = this.OpenCRUDAccessMenu.bind(this);
    this.handleOnOKClick = this.handleOnOKClick.bind(this);
    this.handleOnCancelClick = this.handleOnCancelClick.bind(this);
    this.LoginCorrecto = this.LoginCorrecto.bind(this);
    this.SetNoEditOnConverters = this.SetNoEditOnConverters.bind(this);
  }

  SetNoEditOnConverters() {
    //var x = document.getElementsByClassName("convertername");
  }

  OpenCRUDAccessMenu(open) {
    let CRUDAccess = window.document.getElementById("CRUDAccess");

    if (open === false) {
      CRUDAccess.classList.remove("open");
    } else {
      if (this.props.enableCRUD === false) {
        if (CRUDAccess.classList.contains("open"));
        else {
          CRUDAccess.classList.add("open");
        }
      } else {
        CRUDAccess.classList.remove("open");
        const { setEnableCRUD } = this.props;
        setEnableCRUD(false);
        this.SetNoEditOnConverters();
      }
    }
  }

  LoginCorrecto() {
    let bLoginCorrecto = false;
    let user = window.document.getElementById("user");
    let password = window.document.getElementById("password");

    if (user.value === "admin" && password.value === "converter") bLoginCorrecto = true;
    user.value = "";
    password.value = "";
    return bLoginCorrecto;
  }
  handleOnCancelClick(event) {
    this.OpenCRUDAccessMenu(false); // Close Menu
  }
  handleOnOKClick(event) {
    /* hide or show toolbar y acompañar las opciones de menú según el estado
    Lapicero y menú de cada conversor: buscar por clase */
    const { setEnableCRUD } = this.props;
    const stateEnableCRUD = this.props.enableCRUD;
    if (stateEnableCRUD === false) {
      let bLogin = this.LoginCorrecto();
      if (bLogin === true) {
        setEnableCRUD(true);
        //window.document.getElementById("authentication").style.visibility =  "hidden";
        this.OpenCRUDAccessMenu(false); // Close Menu
      } else {
        alert(currentLocals(this.props.locale).general.Not_CRUD_Config);
        //window.document.getElementById("authentication").style.visibility =  ("visible");
      }
    } else {
      // stateEnableCRUD === true
      window.document.getElementById("authentication").style.visibility = "visible";
      setEnableCRUD(false);
    }
  }
  render() {
    let lockstatusclass = this.props.enableCRUD ? "openlock" : "closelock";
    return (
      <div className="CRUDAccess" style={{ display: "" }}>
        <div className="dropdown btn-group" id="CRUDAccess">
          <button id="Lock" style={{ display: "none" }} onClick={this.OpenCRUDAccessMenu} className={lockstatusclass}>
            &nbsp;
          </button>
          <hr style={{ border: "755px", backgroundColor: "yellow" }}></hr>
          <ul className="dropdown-menu dropdown-menu-right">
            <li id="authentication" className="authentication ">
              <div>
                <label className="labelauth0 labelCRUDTitle" style={{ borderBottom: "1px solid white" }}>
                  {currentLocals(this.props.locale).general.Config_Access}
                </label>
                <br></br>
                <hr style={{ border: "15px", color: "red" }}></hr>
              </div>
            </li>
            <br></br>
            <li id="authentication" className="authentication ">
              <div>
                <label className="labelauth0 labelCRUD">{currentLocals(this.props.locale).general.User}</label>
                <input id="user" className="inputauth0"></input>
              </div>

              <div>
                <label className="labelauth0 labelCRUD"> {currentLocals(this.props.locale).general.Password}</label>
                <input id="password" type="password" className="inputauth0"></input>
              </div>
              <div>
                <input
                  id="Okear"
                  onClick={this.handleOnOKClick}
                  className="btn btn-default buttonOK"
                  value="&#10132;"
                  type="button"
                ></input>
                <input
                  id="Cancel"
                  onClick={this.handleOnCancelClick}
                  className="btn btn-default buttonCancel"
                  value="&#10540;"
                  type="button"
                ></input>
              </div>
              {/*
              <span style={{ float: "initial" }}>
                <FormControl sx={{ marginTop: 1, width: "48%" }}>
                  <MuiLectraButton onClick={(event) => this.handleOnOKClick()}>
                    {currentLocals(this.props.locale).preferences.OK}
                  </MuiLectraButton>
                </FormControl>
                <FormControl sx={{ marginTop: 1, width: "48%" }}>
                  <MuiLectraButton onClick={(event) => this.handleOnCancelClick()} kind="secondary">
                    {currentLocals(this.props.locale).preferences.Cancel}
                  </MuiLectraButton>
                </FormControl>
             </span>*/}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default CRUDAccess;
